import { PartsService } from "@common/client"
import { partStockBaseKey } from "./part-stock"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const partsBaseKey = ["parts"] as const

export const partsSearchKey = (params?: {
  search?: string | null
  skip?: number
  limit?: number
}) => [...partsBaseKey, "search", params] as const

export const partsQuery = makeQuery({
  serviceCall: PartsService.searchParts,
  queryKey: (params) => partsSearchKey(params),
})

export const partManufacturersKey = [...partsBaseKey, "manufacturers"] as const

export const partManufacturersQuery = makeNoArgsQuery({
  serviceCall: PartsService.listManufacturers,
  queryKey: partManufacturersKey,
})

export const useCreatePartMutation = makeAxiosMutation({
  serviceCall: PartsService.createPart,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})

export const useUpdatePartMutation = makeAxiosMutation({
  serviceCall: PartsService.updatePart,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})

export const useArchivePartMutation = makeAxiosMutation({
  serviceCall: PartsService.archivePart,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})

export const useRestorePartMutation = makeAxiosMutation({
  serviceCall: PartsService.restorePart,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})

export const useDeletePartMutation = makeAxiosMutation({
  serviceCall: PartsService.deletePart,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})

export const useDeletePartsMutation = makeAxiosMutation({
  serviceCall: PartsService.deleteParts,
  invalidates: () => [partsBaseKey, partStockBaseKey],
})
